export const deleteButtonStyles = {
    button: 'btn btn-icon modify-del',
};

export const createdRangeButtonStyles = {
    button: 'ico-examscope',
};

export const cteatedEditButtonStyles = {
    button: 'btn btn-icon modify-edit',
};
